<script setup>
// Vista superior simplificada da aeronave, desenhada no sistema de
// coordenadas 200×150. É um <g> — quem usa fornece o <svg> e o viewBox,
// podendo folgar as margens para caber rótulos.
</script>

<template>
  <g fill="#EEF2F7" stroke="#C7D2DE" stroke-width="1.2" stroke-linejoin="round">
    <!-- Hélice -->
    <path d="M100 14v10M86 19h28" stroke-width="2.5" stroke-linecap="round" fill="none" />
    <!-- Fuselagem -->
    <path d="M100 22c6 0 10 9 10 20v76c0 8-4 14-10 14s-10-6-10-14V42c0-11 4-20 10-20z" />
    <!-- Asas -->
    <path d="M92 62 24 84c-3 1-4 3-4 5v6c0 2 2 3 4 3l68-8zM108 62l68 22c3 1 4 3 4 5v6c0 2-2 3-4 3l-68-8z" />
    <!-- Estabilizadores -->
    <path d="M94 118 60 130c-2 1-3 2-3 4v3c0 1 1 2 3 2l34-5zM106 118l34 12c2 1 3 2 3 4v3c0 1-1 2-3 2l-34-5z" />
    <!-- Deriva -->
    <path d="M100 104c4 0 6 8 6 18v10h-12v-10c0-10 2-18 6-18z" />
    <!-- Cabine -->
    <path d="M100 30c4 0 7 6 7 12s-3 8-7 8-7-2-7-8 3-12 7-12z" fill="#DCE5EF" />
  </g>
</template>
